import { createFileRoute } from '@tanstack/react-router';
import { JourneysFormsSettingsHandoff } from '@/pages/workspaces/integrations/forms/routing';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/integrations/forms_/settings')({
  component: JourneysFormsSettingsHandoff,
});
